









import { defineComponent } from '@vue/composition-api';
import AdClient from '@/bundles/Ad/models/AdClient';
import { useAdClient } from '@/bundles/Ad/composables/useAdClient';
import { IAdClient } from '@/bundles/Ad/interfaces';

import AdClientFormBase from '@/bundles/Ad/components/AdClientFormBase.vue';

export default defineComponent({
  name: 'AdClientEditForm',

  components: {
    AdClientFormBase,
  },

  emits: ['item:refresh', 'form:close'],

  props: {
    adClientEntry: {
      type: AdClient,
      required: true,
    },
  },

  setup (_, { emit }) {
    const { editClient, editLoading } = useAdClient();

    async function submitEventHandler (data: Partial<IAdClient>) {
      await editClient(data.id!, { name: data.name!, active: data.active! });
      emit('form:close');
      emit('item:refresh');
    }

    return {
      editLoading,
      submitEventHandler
    };
  },
});
